import React from 'react'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'

import {Icon} from '@vio/atlas/Icon'
import {Tooltip, TooltipPlacement} from '@vio/atlas/Tooltip'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import {useIsSaveFraming} from '../../hooks/useIsSaveFraming'
import {myListMessages} from '../../myListMessages'

const TooltipContent = styled.span`
  .--inline-icon {
    display: inline;
    vertical-align: sub;
  }
`

export const DesktopIcon = () => {
  const {formatMessage} = useIntl()
  const saveFramingIsOn = useIsSaveFraming()

  return (
    <Tooltip
      placement={TooltipPlacement.Top}
      title={
        saveFramingIsOn
          ? formatMessage(myListMessages.onboardingTitle)
          : formatMessage({
              id: 'priceWatchTitle',
              defaultMessage: 'Never miss a price drop'
            })
      }
      content={
        saveFramingIsOn ? (
          <TooltipContent>
            <FormattedMessageWrapper
              {...myListMessages.saveStayDescription}
              values={{
                icon: <Icon className="--inline-icon" name="Heart" size="sm" />
              }}
            />
          </TooltipContent>
        ) : (
          <FormattedMessageWrapper
            id="priceAlertOnboardingDescription"
            defaultMessage="We actively monitor prices in the background and will notify you when the prices change."
          />
        )
      }
    >
      <Icon
        name="Information"
        size="sm"
        colorPath="content.neutral.secondary"
      />
    </Tooltip>
  )
}
